/* eslint-disable react/jsx-no-bind */

import classNames from "classnames";
import { NavLink } from "react-router-dom";
import { twMerge } from "tailwind-merge";

export const SubNavBar = (props: React.PropsWithChildren) => {
  return (
    <nav
      data-testid="SubNavBar"
      className={classNames("z-20 flex flex-col border-b border-b-gray-400", {
        "shadow-xs bg-[#F8FAFC]": !Features.BuildPageDockedAnnotations,
        "bg-white": Features.BuildPageDockedAnnotations,
      })}
    >
      {props.children}
    </nav>
  );
};

export const SubNavBarRow = (props: React.PropsWithChildren<{ className?: string }>) => {
  return (
    <div
      className={twMerge(
        classNames(
          "flex gap-3 px-2.5",
          {
            "h-[44px] bg-[#F8FAFC]": !Features.BuildPageDockedAnnotations,
            "bg-white py-1.5": Features.BuildPageDockedAnnotations,
          },
          props.className,
        ),
      )}
    >
      {props.children}
    </div>
  );
};

export const SubNavLink = (props) => {
  return (
    <NavLink
      {...props}
      className={({ isActive }) =>
        twMerge(
          classNames(
            "self-center px-2 py-1 text-sm",
            "flex items-center justify-center rounded-md border border-gray-400",
            "text-charcoal-400 no-underline hover:text-current hover:no-underline focus:text-current focus:no-underline",
            "transition-colors duration-75 hover:border-slate-400 hover:bg-white",
            {
              "text-charcoal-700 shadow-xs border-slate-500 bg-white": isActive,
            },
          ),
        )
      }
    />
  );
};
